export default function socialTitle() {
  const widgetName = 'socialTitle';
  const widgetOpts = socialTitleOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    link: ['all'],

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createSocialTitle(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createSocialTitle(widgetData) {
    const { Title, Description } = widgetData.items[0];
    $widget.empty();
    $widget.replaceWith(`
      <div class="social-title">
          <span class="upper-title">${Description}</span>
          <span class="title">${Title}</span>
        </div>
    `);
  }
}
